import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import { SearchBarNew } from '../../SearchBarNew'
import { ExportBtn } from '../../ExportBtn'

export default function SearchHeader({
  showActions = false, // whether to show searchbar etc eg. don't show when on first load and no results
  selectOptions,
  rightSideComponent,
  title,
  desc,
  searchPlaceholder,
  setSearchTerm,
  data, // data to be exported
  exportedData, // type of data to export
  eventName, // event name for export file
  packageName, // package name for export file
  flexPackName, // flex pack name for export file
  organizationName, // organization name for export file
  downloadReport, // optional custom export callback
  actionsRightComponent, // optional extra action rendered next to the export button
}) {
  return (
    <>
      <header className="section-header section-heading--flex section-heading section-heading--secondary">
        <div className="section-heading">
          <h1>{title}</h1>
          <p className="section-header-desc">{desc}</p>
        </div>
        {/* isEventSoldOut || hasEventEnded */}
        {/* openTicketTypeModal */}
        {rightSideComponent}
      </header>
      {showActions && (
        <header className="section-header">
          <div className="actions-group-flex">
            {selectOptions.show && (
              <FloatingLabel
                controlId="invoices"
                id={`${selectOptions.labelId}-label`}
                label={selectOptions.label}
              >
                <Form.Select
                  value={selectOptions.value}
                  onChange={(e) => selectOptions.handleChange(e.target.value)}
                  aria-labelledby={`${selectOptions.labelId}-label`}
                >
                  {selectOptions.options.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            )}

            {/* handleSearchChange */}
            <SearchBarNew
              onQueryChange={(value) => setSearchTerm(value)}
              placeholder={searchPlaceholder}
            />

            <ExportBtn
              data={data}
              exportedData={exportedData}
              eventName={eventName}
              packageName={packageName}
              flexPackName={flexPackName}
              organizationName={organizationName}
              downloadReport={downloadReport}
            />

            {actionsRightComponent}
          </div>
        </header>
      )}
    </>
  )
}
